(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orotech-mold-form"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.mr-form__wrap').forEach(function (wrap) {
    var submitBtn  = wrap.querySelector('.mr-submit-btn');
    var formFields = wrap.querySelector('.mr-form__fields');
    var successEl  = wrap.querySelector('.mr-form__success');
    var resetBtn   = wrap.querySelector('.mr-form__reset');
    var fileInput  = wrap.querySelector('input[type="file"]');
    var dropzone   = fileInput ? fileInput.closest('.mr-field').querySelector('.mr-dropzone__label') : null;

    if (fileInput && dropzone) {
      fileInput.addEventListener('change', function() {
        if (fileInput.files.length > 0) {
          dropzone.textContent = fileInput.files.length + ' failas(-ai) pasirinkta';
        }
      });
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', function() {
        if (formFields && successEl) {
          formFields.style.display = 'none';
          successEl.style.display = 'block';
        }
      });
    }
    if (resetBtn) {
      resetBtn.addEventListener('click', function() {
        if (formFields && successEl) {
          successEl.style.display = 'none';
          formFields.style.display = 'flex';
        }
      });
    }
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orotech-mold-removal"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var submitBtn  = document.getElementById('mr-submit-btn');
  var formFields = document.getElementById('mr-form-fields');
  var successEl  = document.getElementById('mr-form-success');
  var resetBtn   = document.getElementById('mr-form-reset');
  var fileInput  = document.getElementById('mr-file-input');
  var dropzone   = fileInput ? fileInput.closest('.mr-field').querySelector('.mr-dropzone__label') : null;

  if (fileInput && dropzone) {
    fileInput.addEventListener('change', function() {
      if (fileInput.files.length > 0) {
        dropzone.textContent = fileInput.files.length + ' failas(-ai) pasirinkta';
      }
    });
  }

  if (submitBtn) {
    submitBtn.addEventListener('click', function() {
      if (formFields && successEl) {
        formFields.style.display = 'none';
        successEl.style.display = 'block';
      }
    });
  }
  if (resetBtn) {
    resetBtn.addEventListener('click', function() {
      if (formFields && successEl) {
        successEl.style.display = 'none';
        formFields.style.display = 'flex';
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orotech-returns"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  /* ── Reason pills ─── */
  var pills = document.querySelectorAll('.rt-pill');
  var reasonInput = document.getElementById('rt-reason-val');
  pills.forEach(function(pill) {
    pill.addEventListener('click', function() {
      pills.forEach(function(p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');
      if (reasonInput) reasonInput.value = pill.dataset.reason;
    });
  });

  /* ── Form submit ─── */
  var submitBtn  = document.getElementById('rt-submit-btn');
  var formFields = document.getElementById('rt-form-fields');
  var successEl  = document.getElementById('rt-form-success');
  var resetBtn   = document.getElementById('rt-form-reset');

  if (submitBtn) {
    submitBtn.addEventListener('click', function() {
      if (formFields && successEl) {
        formFields.style.display = 'none';
        successEl.style.display = 'block';
      }
    });
  }
  if (resetBtn) {
    resetBtn.addEventListener('click', function() {
      if (formFields && successEl) {
        successEl.style.display = 'none';
        formFields.style.display = 'flex';
      }
    });
  }

  /* ── FAQ ─── */
  var faqItems = document.querySelectorAll('.rt-faq__item');
  faqItems.forEach(function(item) {
    var btn = item.querySelector('.rt-faq__q');
    if (!btn) return;
    btn.addEventListener('click', function() {
      var isOpen = item.classList.contains('is-open');
      faqItems.forEach(function(i) {
        i.classList.remove('is-open');
        var b = i.querySelector('.rt-faq__q');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orotech-shipping"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var faqItems = document.querySelectorAll('.sh-faq__item');
  faqItems.forEach(function(item) {
    var btn = item.querySelector('.sh-faq__q');
    if (!btn) return;
    btn.addEventListener('click', function() {
      var isOpen = item.classList.contains('is-open');
      faqItems.forEach(function(i) {
        i.classList.remove('is-open');
        var b = i.querySelector('.sh-faq__q');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orotech-warranty"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  /* ── Symptom pill selection ─── */
  var pills = document.querySelectorAll('.wt-pill');
  var symptomInput = document.getElementById('wt-symptom-val');
  pills.forEach(function(pill) {
    pill.addEventListener('click', function() {
      pills.forEach(function(p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');
      if (symptomInput) symptomInput.value = pill.dataset.symptom;
    });
  });

  /* ── Claim form submit / success ─── */
  var submitBtn = document.getElementById('wt-submit-btn');
  var formEl    = document.getElementById('wt-claim-form');
  var successEl = document.getElementById('wt-claim-success');
  var resetBtn  = document.getElementById('wt-claim-reset');

  if (submitBtn) {
    submitBtn.addEventListener('click', function() {
      if (formEl && successEl) {
        formEl.style.display = 'none';
        successEl.style.display = 'block';
      }
    });
  }
  if (resetBtn) {
    resetBtn.addEventListener('click', function() {
      if (formEl && successEl) {
        successEl.style.display = 'none';
        formEl.style.display = 'flex';
      }
    });
  }

  /* ── FAQ accordion ─── */
  var faqItems = document.querySelectorAll('.wt-faq__item');
  faqItems.forEach(function(item) {
    var btn = item.querySelector('.wt-faq__q');
    if (!btn) return;
    btn.addEventListener('click', function() {
      var isOpen = item.classList.contains('is-open');
      faqItems.forEach(function(i) {
        i.classList.remove('is-open');
        var b = i.querySelector('.wt-faq__q');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

});

  } catch(e) { console.error(e); }
})();
})();
